/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import getEventRepeatFieldDefaults from '../helpers/getEventRepeatFieldDefaults';

import FormFieldEventRepeat from '../components/formFieldEventRepeat';

const FormFieldEventRepeatContainer = ({ fieldId, schema, updateField, value = null }) => {
  const initialModel = {
    ...getEventRepeatFieldDefaults({ currentFrequency: value?.frequency }),
    ...value,
  };

  const [model, setModel] = useState(initialModel);

  const updateFormField = (updateObject) => {
    setModel(updateObject);
    updateField(updateObject);
  };

  const handleChange = ({ key, updateValue }) => {
    const updateLogic = {
      // Reset all values when frequency is changed
      frequency: () =>
        updateFormField({
          ...getEventRepeatFieldDefaults({ currentFrequency: updateValue }),
          ...(updateValue === 'monthly' && { by: 'date' }),
          [key]: updateValue,
        }),
      // Set true on the specific day that was checked
      days: () =>
        updateFormField({
          ...model,
          [key]: Object.fromEntries(
            Object.entries({ ...model.days, ...updateValue }).filter(([_, value]) => value),
          ),
        }),
      // Every other key set using standard update convention
      default: () =>
        updateFormField({
          ...model,
          [key]: updateValue,
        }),
    };

    const updateFunction = updateLogic[key] || updateLogic.default;

    updateFunction();
  };

  return (
    <FormFieldEventRepeat
      fieldId={fieldId}
      handleChange={handleChange}
      model={model}
      schema={schema}
    />
  );
};

FormFieldEventRepeatContainer.propTypes = {
  schema: PropTypes.shape({ isDisabled: PropTypes.bool }).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      frequency: PropTypes.string,
      interval: PropTypes.number,
      by: PropTypes.string,
      until: PropTypes.string,
      days: PropTypes.shape({}),
    }),
    PropTypes.number,
  ]),
  updateField: PropTypes.func.isRequired,
};

registerField('EventRepeat', React.memo(FormFieldEventRepeatContainer));
